export const CCNTR_LEVEL_DOMAIN = "CCNTR_LEVEL";

//Asset Type
export const ASSET_TYPE_DOMAIN = "ASSET_TYPE";
export const ASSET_TYPE_ASSET_CODE = "Asset";
export const ASSET_TYPE_FIREARM_CODE = "Firearm";

export const ASSET_TYPE_FIREARM_ASSET_NAME = "Firearm Asset";

export const FIREARM_STORAGE_LOCATION_RANGER_HOME = "Ranger Home"


